import { compressImage } from "../helpers/system";

export const SelectAutoSearchOptionsCount = 10;

export const UploadFileCount = 10;
export const UploadFileNameLength = 100;
export const UploadFileMaxSize = 5e6;
export const UploadFileAllowedMimeTypes = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/pjpg",
    "image/pjpeg",
];
export const UploadFileCompression = [
    {
        function: compressImage,
        functionParams: [0.6],
        mimeTypes: ["image/png", "image/jpeg", "image/jpg", "image/pjpg", "image/pjpeg"],
    },
];

export const DateDiffRx = /([0-9]+)([ymd])/i;

export const OTPSize = 4;
export const OTPType = "numeric"; // numeric, alpha, numeric-alpha, alpha-sensitive, numeric-alpha-sensitive
export const OTPTypes = ["numeric", "alpha", "numeric-alpha", "alpha-sensitive", "numeric-alpha-sensitive", "custom"];
export const OTPValidation = {
    "numeric": "[0-9]",
    "alpha": "[a-zA-Z]",
    "numeric-alpha": "[a-zA-Z0-9]",
    "alpha-sensitive-lower": "[a-z]",
    "alpha-sensitive-upper": "[A-Z]",
    "numeric-alpha-sensitive-lower": "[a-z0-9]",
    "numeric-alpha-sensitive-upper": "[A-Z0-9]",
};
